import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, ChevronDown } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToIncludes = () => {
    document.getElementById('includes')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-brand-cream pt-6 pb-10 md:pt-12 md:pb-20 overflow-hidden" data-id="element-50">
      <div className="absolute inset-0 bg-court-pattern opacity-50 pointer-events-none" data-id="element-51"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-53">
          <div className="inline-flex items-center justify-center space-x-2 bg-brand-dark text-white px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-sm font-bold tracking-wide mb-4 md:mb-6 uppercase" data-id="element-54">
            <span className="text-brand-orange" data-id="element-55">🏀</span>
            <span data-id="element-56">Sistema N°1 para Profes de Básquet en Argentina</span>
          </div>

          <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-display text-brand-dark leading-[0.9] mb-4 md:mb-6" data-id="element-57">
            MEGAPACK BÁSQUET <br className="hidden md:block" data-id="element-58" />
            <span className="text-brand-orange" data-id="element-59">RESUELTO</span>
          </h1>

          {/* Product Mockup — 70% scale */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.85,
          y: 30
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: 'easeOut'
        }} className="w-[70%] max-w-xl mx-auto mb-6 md:mb-8" data-id="element-60">
            <img src="https://cdn.magicpatterns.com/uploads/qWTuZY1jXWHEGgiQbAkfxs/mockupardo.png" alt="Megapack Básquet Resuelto — mockup del producto con todos los tomos y bonos incluidos" className="w-full h-auto drop-shadow-2xl" loading="eager" data-id="element-61" />
          </motion.div>

          <p className="text-base md:text-xl text-gray-700 max-w-3xl mx-auto font-medium mb-6 md:mb-8 leading-relaxed" data-id="element-62">
            Organizá tu temporada completa, tus prácticas y tu equipo en menos
            de 1 semana. Todo el sistema para entrenar básquet de 5 a 17 años
            listo para descargar y aplicar desde hoy.
          </p>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-6 md:mb-10" data-id="element-63">
            {['PDF Digital', 'Acceso Inmediato', '5 a 17 años', '660+ páginas'].map((stat, i) => <div key={i} className="flex items-center space-x-1.5 md:space-x-2 bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-md shadow-sm border border-gray-100" data-id="element-64">
                <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-brand-orange" data-id="element-65"></div>
                <span className="font-bold text-xs md:text-base text-brand-dark" data-id="element-66">
                  {stat}
                </span>
              </div>)}
          </div>

          <div className="flex flex-col items-center space-y-2 md:space-y-4" data-id="element-67">
            <motion.button onClick={scrollToPricing} whileTap={{
            scale: 0.97
          }} className="w-full md:w-auto bg-brand-orange hover:bg-orange-600 text-white font-display text-xl md:text-3xl px-6 py-4 md:px-10 md:py-5 rounded-lg shadow-[0_6px_0_#cc5500] md:shadow-[0_8px_0_#cc5500] active:shadow-[0_0px_0_#cc5500] active:translate-y-2 transition-all flex items-center justify-center" data-id="element-68">
              <span data-id="element-69">🏀 QUIERO MI BÁSQUET RESUELTO</span>
            </motion.button>

            <button onClick={scrollToIncludes} className="text-gray-500 hover:text-brand-dark text-sm md:text-base font-bold flex items-center space-x-1 transition-colors mt-2 md:mt-4" data-id="element-70">
              <span data-id="element-71">Ver qué incluye</span>
              <ChevronDown size={18} data-id="element-72" />
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 mt-6 md:mt-12 text-xs md:text-sm font-semibold text-gray-600" data-id="element-73">
            <div className="flex items-center space-x-1.5" data-id="element-74">
              <ShieldCheck size={16} className="text-green-600" data-id="element-75" />
              <span data-id="element-76">Garantía 7 días</span>
            </div>
            <div className="flex items-center space-x-1.5" data-id="element-77">
              <Lock size={16} className="text-gray-400" data-id="element-78" />
              <span data-id="element-79">Pago seguro</span>
            </div>
            
          </div>
        </motion.div>
      </div>
    </section>;
}